import "./Galeria.css";

import {
  FaInstagram,
  FaArrowRight,
  FaQrcode,
} from "react-icons/fa";

import proyectoVideo from "../assets/videos/yanna-video.mp4";
import Instagram from "../assets/Instagram.png";

function Galeria() {
  return (
    <section
      className="project-gallery"
      id="galeria"
    >
      {/* ENCABEZADO */}

      <div className="project-gallery-heading">
        <span>GALERÍA DEL PROYECTO</span>

        <h2>Conoce Nuestro Proyecto</h2>

        <p>
          Explora cada detalle de YANNA A&amp;P CONSTRUCTIONS,
          un proyecto residencial diseñado para brindarte{" "}
          <strong>
            confort, elegancia, seguridad y calidad
          </strong>{" "}
          en cada espacio.
        </p>
      </div>

      {/* VIDEO */}

      <div className="project-video-wrapper">
        <video
          className="project-video"
          src={proyectoVideo}
          controls
          playsInline
          preload="metadata"
        >
          Tu navegador no soporta la reproducción de video.
        </video>
      </div>

      {/* INSTAGRAM */}

      <div className="project-instagram-section">

        <div className="project-instagram-info">

          <div className="project-instagram-icon">
            <FaInstagram />
          </div>

          <span className="project-instagram-label">
            SÍGUENOS EN INSTAGRAM
          </span>

          <h3>
            Conoce más de nuestros proyectos
          </h3>

          <p>
            Descubre novedades, avances de construcción,
            detalles de nuestros apartamentos y contenido
            exclusivo de YANNA A&amp;P CONSTRUCTIONS.
          </p>

          <a
            href="https://www.instagram.com/yannaap_constructions/"
            target="_blank"
            rel="noopener noreferrer"
            className="project-instagram-button"
          >
            <FaInstagram />

            <span>Ver perfil en Instagram</span>

            <FaArrowRight />
          </a>

        </div>

        {/* IMAGEN / QR DE INSTAGRAM */}

        <div className="project-instagram-qr">

          <div className="project-instagram-qr-header">
            <FaQrcode />

            <span>Escanea el código</span>
          </div>

          <div className="project-instagram-qr-image">
            <img
              src={Instagram}
              alt="Instagram de YANNA A&P Constructions"
            />
          </div>

          <p>
            Escanea con la cámara de tu teléfono
          </p>

        </div>

      </div>
    </section>
  );
}

export default Galeria;